import { useTheme } from '@mui/material';
import { FocusTheme } from '@/components/Focus/configs/theme';

export const useFocusTheme = () => {
  return useTheme<FocusTheme>();
};
